import { connect } from "react-redux";

import { requestLogout } from "../../../../store/authentication/thunks";
import ChangePasswordSuccess from "./ChangePasswordSuccess";
import { State } from "../../../../store/state";

const mapStateToProps = (state: State) => ({});

const mapDispatchToProps = {
  requestLogout
};

const ChangePasswordSuccessContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePasswordSuccess);

export default ChangePasswordSuccessContainer;
